import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Filter, FilterOneValue } from '@docpath/linces-angular-components/common';
import { DpPaginationModule, DpTableModule, Table } from '@docpath/webcomponents';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from 'src/app/constants/constants';

import { StatisticsService } from '../../services/statistics.service';
import { StatisticsHttpService } from '../../services/statistics-http.service';
import { StatisticsTableService } from './statistics-table.service';

@Component({
  selector: 'app-statistics-table',
  templateUrl: './statistics-table.component.html',
  standalone: true,
  imports: [DpTableModule, DpPaginationModule]
})
export class StatisticsTableComponent implements OnInit {
  @Input() filters: Filter[] = [];
  @Output() selectedRow = new EventEmitter<void>();
  @Output() tableLoaded = new EventEmitter<Table>();

  table: Table;
  showLoading = false;

  @Input() dgeId: number = 0;
  numberHours?: number;
  customNumberHoursFrom?: string;
  customNumberHoursTo?: string;
  lastJobId?: number;

  private readonly statisticsTableService = inject(StatisticsTableService);
  private readonly statisticsService = inject(StatisticsService);
  private readonly statisticsHttpService = inject(StatisticsHttpService);
  private readonly translateService = inject(TranslateService);

  constructor() {
    this.table = this.statisticsTableService.initTable();
    this.statisticsTableService.refreshColumns(this.table);
  }

  ngOnInit(): void {
    this.statisticsService.statisticsSelectsChanged.subscribe(statisticsFilter => {
      this.dgeId = statisticsFilter.dgeId;
      this.numberHours = statisticsFilter.numberHours;
      this.customNumberHoursFrom = statisticsFilter.customNumberHoursFrom;
      this.customNumberHoursTo = statisticsFilter.customNumberHoursTo;
      this.lastJobId = statisticsFilter.lastJobId;

      this.statisticsTableService.loadJobs(false, this.dgeId ?? Constants.DGE_ALL_VALUES, this.numberHours ?? Constants.NUMBER_OF_HOURS_24,
        this.customNumberHoursFrom ?? '', this.customNumberHoursTo ?? '', this.lastJobId ?? 0, [], 1, 25);
    });

    this.statisticsTableService.jobsLoaded.subscribe(result => {
      this.table.header = this.statisticsTableService.initTableHeader();
      this.table.body = this.statisticsTableService.initTableBody(result);
      this.statisticsTableService.refreshColumns(this.table);
    });

    this.statisticsHttpService.showLoadingTableChanged.subscribe(showLoading => {
      this.showLoading = showLoading;
    });
    this.statisticsTableService.loadJobs(true, this.dgeId ?? Constants.DGE_ALL_VALUES, this.numberHours ?? Constants.NUMBER_OF_HOURS_24,
      this.customNumberHoursFrom ?? '', this.customNumberHoursTo ?? '', this.lastJobId ?? 0, [{ 'condition': 'equal-to', 'key': 'preview', 'value': 'No' } as FilterOneValue], 1, 25);
    this.tableLoaded.emit(this.table);

    this.translateService.onLangChange.subscribe(() => {
      this.statisticsTableService.loadJobs(false, this.dgeId ?? Constants.DGE_ALL_VALUES, this.numberHours ?? Constants.NUMBER_OF_HOURS_24,
        this.customNumberHoursFrom ?? '', this.customNumberHoursTo ?? '', this.lastJobId ?? 0, this.filters, this.getCurrentPage(), this.getCurrentSize());
    });
  }

  onChangeCheck(): void {
    this.selectedRow.emit();
  }

  onChangePage(page: number): void {
    this.statisticsTableService.loadJobs(true, this.dgeId ?? Constants.DGE_ALL_VALUES, this.numberHours ?? Constants.NUMBER_OF_HOURS_24,
      this.customNumberHoursFrom ?? '', this.customNumberHoursTo ?? '', this.lastJobId ?? 0, this.filters, page);
    this.statisticsService.notifyStatisticsTablePaginationChange();
  }

  onChangePageSize(size: number): void {
    this.statisticsTableService.loadJobs(true, this.dgeId ?? Constants.DGE_ALL_VALUES, this.numberHours ?? Constants.NUMBER_OF_HOURS_24,
      this.customNumberHoursFrom ?? '', this.customNumberHoursTo ?? '', this.lastJobId ?? 0, this.filters, 1, size);
    this.statisticsService.notifyStatisticsTablePaginationChange();
  }

  getCurrentPage(): number {
    return this.statisticsTableService.getCurrentPage();
  }

  getCurrentSize(): number {
    return this.statisticsTableService.getCurrentSize();
  }

  getElements(): number {
    return this.statisticsTableService.getElements();
  }
}
